/// <reference types="grecaptcha" />

import('./bootstrap').catch(err => console.error(err));
